export default __webpack_public_path__ + "static/media/CW__2899.1024e803.jpg";